import { useCallback, useMemo } from 'react';
import {
	BOARD,
	PROJECT,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/item-type.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { DROPDOWN_ITEM } from '../../constants/analytics/action-subject-type.tsx';
import { CUSTOM_ITEM_DROPDOWN_ACTION } from '../../constants/analytics/component-type.tsx';
import { LEVEL_FOUR } from '../../constants/analytics/level.tsx';
import {} from '../../constants/analytics/section-type.tsx';
import type {
	BoardMeatballDropdownMenuItemParams,
	ProjectMeatballDropdownMenuItemParams,
} from '../types.tsx';
import { getSectionByStarredOrRecent } from '../utils.tsx';

export const useProjectsAnalyticsL4 = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const commonAttributes = useMemo(
		() => ({
			level: LEVEL_FOUR,
		}),
		[],
	);

	// actions inside meatball menu on boards
	const sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent = useCallback(
		({
			itemId,
			recent,
			starred,
			boardId,
			projectId,
			projectType,
		}: BoardMeatballDropdownMenuItemParams): void => {
			const event = createAnalyticsEvent({
				action: 'clicked',
				actionSubject: DROPDOWN_ITEM,
			});

			const attributes = {
				...commonAttributes,
				componentType: CUSTOM_ITEM_DROPDOWN_ACTION,
				itemId,
				parentItemId: boardId,
				parentItemType: BOARD,
				projectId,
				projectType,
				section: getSectionByStarredOrRecent({ starred, recent }),
			};
			fireUIAnalytics(event, 'projectsNavigationMenuItem', attributes);
		},
		[commonAttributes, createAnalyticsEvent],
	);

	// actions inside meatball menu on projects
	const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = useCallback(
		({
			itemId,
			recent,
			starred,
			projectId,
			projectType,
		}: ProjectMeatballDropdownMenuItemParams): void => {
			const event = createAnalyticsEvent({
				action: 'clicked',
				actionSubject: DROPDOWN_ITEM,
			});

			const attributes = {
				...commonAttributes,
				componentType: CUSTOM_ITEM_DROPDOWN_ACTION,
				itemId,
				parentItemId: projectId,
				parentItemType: PROJECT,
				projectId,
				projectType,
				section: getSectionByStarredOrRecent({ starred, recent }),
			};
			fireUIAnalytics(event, 'projectsNavigationMenuItem', attributes);
		},
		[commonAttributes, createAnalyticsEvent],
	);

	return {
		sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent,
		sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
	};
};
